import ConditionalLoader from "core/components/ConditionalLoader"
import DashboardLayout from "core/layouts/DashboardLayout"
import { useEffect } from "react"
import useCreateProgressMeetingViewModel from "./CreateProgressMeetingViewModel"
import { isEmpty, removeAtIndex } from "core/utils/misc"
import { AddIcon, CrossIcon } from "core/constants/svgs"
import StandaredSelect from "core/components/StandaredSelect"
import Input from "core/components/new/Input"
import { STR_DATE_AND_TIME_FIELD, STR_TEXT_FIELD } from "core/constants/strings"
import Button from "core/components/new/Button"
import Toast from "core/components/Toast"
import { Textarea } from "core/components/v2/Textarea"

export default function CreateProgressMeetingView() {
  const {
    toast,
    progressMeetingName,
    handleProgressMeetingNameChange,
    batch,

    classLink,
    selectSessionTimestamp,

    selectBatch,
    selectInstructor,
    summary,

    currentSelectBatch,
    loading,

    DurationArray,
    handleSummaryChange,
    sessionDuration,
    otherSessionDuration,
    setSessionDuration,
    setOtherSessionDuration,
    handleSessionDuration,
    handleOtherSessionDuration,

    setSelectBatch,

    setCurrentSelectBatch,

    handleBatchChange,
    handleChangeClassLink,
    handleChangeInstructor,

    handleChangeSessionTimestamp,
    changeToastVisibility,
    createClasses,

    getBatches,
  } = useCreateProgressMeetingViewModel()
  useEffect(() => {
    getBatches()
  }, [])

  return (
    <DashboardLayout>
      <>
        <div className="space-y-6 p-6">
          <div className="w-full space-y-1">
            <h2 className="text-new-accent">Create Progress Meeting</h2>
            <p>Creating progress meeting for students</p>
          </div>
          <div className="round-2 mx-auto flex w-full max-w-[600px] flex-col gap-4 p-6 shadow">
            <ul className="flex w-full flex-wrap gap-4 border py-2 px-4">
              <ConditionalLoader
                isLoading={isEmpty(selectBatch)}
                loader={<em className="text-xs text-new-neutral-light">No batches selected</em>}
              >
                {selectBatch.map((batch: any, i: number) => (
                  <li key={i} className="inline-flex items-center gap-2">
                    {batch}
                    <button
                      className="rounded bg-new-solid-black p-1 text-new-solid-white"
                      onClick={() => {
                        setSelectBatch(removeAtIndex(selectBatch, i))
                        setCurrentSelectBatch("")
                      }}
                    >
                      <CrossIcon className="h-4 w-4" />
                    </button>
                  </li>
                ))}
              </ConditionalLoader>
            </ul>
            <StandaredSelect
              required
              options={batch}
              placeholder="Select Batch"
              onChange={handleBatchChange}
              value={currentSelectBatch}
            />
            <Input
              required
              type="text"
              placeholder="Progress Meeting Name"
              className="w-full appearance-none rounded-sm border border-new-neutral bg-new-solid-white px-4 py-2 text-sm leading-[17px] text-new-neutral outline-none focus:border-new-accent focus:ring-1 focus:ring-new-accent"
              onChange={handleProgressMeetingNameChange}
              value={progressMeetingName}
            ></Input>
            <Input type={STR_TEXT_FIELD} value={classLink} onChange={handleChangeClassLink} placeholder="Class Link" />
            <Input
              required
              type="text"
              placeholder="Batch Manager"
              className="w-full appearance-none rounded-sm border border-new-neutral bg-new-solid-white px-4 py-2 text-sm leading-[17px] text-new-neutral outline-none focus:border-new-accent focus:ring-1 focus:ring-new-accent"
              onChange={handleChangeInstructor}
              value={selectInstructor}
            ></Input>

            <Input
              type={STR_TEXT_FIELD}
              value={selectSessionTimestamp}
              onChange={handleChangeSessionTimestamp}
              placeholder="Session Time"
              onBlur={(e) => (e.target.type = STR_TEXT_FIELD)}
              onFocus={(e) => (e.target.type = STR_DATE_AND_TIME_FIELD)}
            />
            <StandaredSelect
              required
              options={DurationArray}
              value={sessionDuration}
              onChange={handleSessionDuration}
              placeholder="Session Duration (in hrs)"
            />
            {sessionDuration == "other" && (
              <Input
                required
                type="number"
                value={otherSessionDuration}
                onChange={handleOtherSessionDuration}
                placeholder="Session Duration (in hrs)"
              />
            )}
            <Textarea value={summary} onChange={handleSummaryChange}></Textarea>

            <Button
              disabled={
                loading ||
                !classLink ||
                !summary ||
                !sessionDuration ||
                !selectBatch ||
                !selectSessionTimestamp ||
                !progressMeetingName
              }
              loading={loading}
              onClick={createClasses}
            >
              Create Progress Meeting
            </Button>
          </div>
        </div>
      </>
      <Toast data={toast} onClick={() => changeToastVisibility(false)} />
    </DashboardLayout>
  )
}
